import { useCallback, useState, useEffect } from "react";
import Select, { MultiValue, StylesConfig } from "react-select";
import { Option } from "../../interface/Option";
import { benefit, Datum } from "../../interface/Benefit";
import { BenefitAxiosInstance } from "../../Network/BenefitAxiosInstance";

const ListOfBenefitName = ({ onChange, clear, defaultValue }: any) => {
  const [options, setOptions] = useState<Option[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<Option[]>(defaultValue || []);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState<string>("");

  // Load options based on input
  const loadOptions = useCallback(async () => {
    if (inputValue.trim().length < 3) {
      setOptions([]);
      return;
    }

    setLoading(true);
    try {
      const response = await BenefitAxiosInstance.get<benefit>("searchBenefit", {
        params: { name: inputValue },
      });
      console.log("API Response:", response.data);

      const data: Datum[] = response.data?.result || [];
      console.log("Data Loaded:", data);

      const formattedOptions: Option[] = data.map((item: Datum) => ({
        value: item.id.toString(),
        label: `(${item.id}) ${item.name}`,
      }));

      setOptions(formattedOptions);
    } catch (error) {
      console.error("Error loading options:", error);
    } finally {
      setLoading(false);
    }
  }, [inputValue]);

  // Debounce API calls
  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      loadOptions();
    }, 300);

    return () => clearTimeout(debounceTimeout);
  }, [inputValue, loadOptions]);

  // Handle selection change
  const handleChange = (selected: MultiValue<Option>) => {
    setSelectedOptions(selected as Option[]);
    onChange(selected as Option[]);
  };

  // Reset selected options when clear is triggered
  useEffect(() => {
    if (clear) {
      setSelectedOptions([]);
    }
  }, [clear]);

  // Set default values on load
  useEffect(() => {
    if (defaultValue) {
      setSelectedOptions(defaultValue);
    }
  }, [defaultValue]);

  // Custom styles for react-select
  const customStyles: StylesConfig<Option, true> = {
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "#007BFF",
      color: "#FFFFFF",
      borderRadius: "5px",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: "#FFFFFF",
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: "#FFFFFF",
      ":hover": {
        backgroundColor: "#0056b3",
        color: "#FFFFFF",
      },
    }),
    option: (styles, { isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "#007BFF" : "#FFFFFF",
      color: isSelected ? "#FFFFFF" : "#000000",
      ":hover": {
        backgroundColor: "#0056b3",
        color: "#FFFFFF",
      },
    }),
  };

  return (
    <Select
      isMulti
      value={selectedOptions}
      onChange={handleChange}
      options={options}
      isLoading={loading}
      onInputChange={setInputValue}
      placeholder="Type at least 3 letters to search..."
      styles={customStyles}
    />
  );
};

export default ListOfBenefitName;